<i18n>
{
  "en": {
    "productMaster": "Product master",
    "add": "Add",
    "createProductMasterSuccess":  "Created product master \"{0}\" !",
    "createProductMasterError": "Error creating product master. Please, try again later.",
    "editProductMasterSuccess": "The master product \"{0}\" was successfully edited",
    "editProductMasterError": "Error editing master product",
    "deleteProductMasterSuccess":  "The mas product \"{0}\" was deleted",
    "deleteProductMasterError": "Error in deleting master product",
    "deleteProductMasterTitle": "Do you want to delete this master product: \"{0}\" ?",
    "deleteProductMasterDescription":"This can not be undone",
    "delete": "Delete",
    "propagateProductMaster": "Propagate to all assigned products",
    "propagateProductMasterDescription":"This will overwrite the following products: ",
    "propagate": "Propagate",
    "propagateProductMasterSuccess":  "The master product \"{0}\" was successfully propagated",
    "propagateProductMasterError": "Error in propagate the master product"
  },
  "es": {
    "productMaster": "Productos maestros",
    "add": "Añadir",
    "createProductMasterSuccess":  "Creado el producto maestro \"{0}\" !",
    "createProductMasterError": "Error creando el product maestro. Inténtelo de nuevo más tarde.",
    "editProductMasterSuccess": "El producto maestro \"{0}\" se edito correctamente",
    "editProductMasterError": "Error editando el producto maestro",
    "deleteProductMasterSuccess":  "El producto maestro \"{0}\" se ha eliminado",
    "deleteProductMasterError": "Error eliminado el producto maestro",
    "deleteProductMasterTitle": "¿Desea borrar el product maestro \"{0}\" ?",
    "deleteProductMasterDescription": "Este cambio es irreversible",
    "delete": "Eliminar",
    "propagateProductMaster": "Propagar hacia todos los productos asignados",
    "propagateProductMasterDescription":"Esto sobreescribira los siguientes productos: ",
    "propagate": "Propagar",
    "propagateProductMasterSuccess":  "El producto maestro \"{0}\" se propagó con éxito",
    "propagateProductMasterError": "Error al propagar el producto maestro"
  }
}
</i18n>
<template>
  <div>
    <div class="d-flex flex-wrap mx-7 mt-3 mb-3">
      <v-row>
        <v-col cols="12" align-self="center" class="pa-0 my-4">
          <div class="text-center text-h5">
            {{ $t('productMaster') }}
          </div>
        </v-col>
        <product-master-filter
          @productMasterSearch="onProductMasterSearch"
        >
        </product-master-filter>
        <v-col cols="1" align-self="center" class="pa-0 te">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon class="plus-icon mr-0" v-on="on" v-bind="attrs"
                     @click="openModal">
                <v-icon color="grey" large>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('add') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
    <v-divider />
    <v-list>
      <div v-if="filteredProductMasterList">
        <product-master-row
          v-for="productMaster in filteredProductMasterList"
          :key="productMaster.guid"
          :productMaster="productMaster"
          @edit="onEdit(productMaster)"
          @delete="onDelete(productMaster)"
          @propagate="onPropagate(productMaster)"
        >
        </product-master-row>
      </div>
    </v-list>
    <product-master-create-edit-modal
      :visible="createEditProductMasterModal"
      @confirm="onConfirmProductMaster"
      @cancel="onCloseModal"
      :productMaster="selectProductMaster"
      :type="typeModal"
      :featureList="masterFeatureList"
      :productList="productSearchList"
      :productSearchRequest="masterProductListSearchRequest"
      :productSearchProgress="productSearchProgress"
      :pointOfSaleList="pointOfSaleList"
    />
    <dynameat-confirmation-modal :visible="deleteConfirmationModal"
                                 :title="$t('deleteProductMasterTitle', [selectProductMaster ? selectProductMaster.name : ''])"
                                 :description="$t('deleteProductMasterDescription')"
                                 :confirm-text="$t('delete')" @confirm="onConfirmDelete"
                                 @cancel="onCloseModal"/>
    <product-master-propagate-modal :visible="propagateModal"
                                 :title="$t('propagateProductMaster', [selectProductMaster ? selectProductMaster.name : ''])"
                                 :description="$t('propagateProductMasterDescription')"
                                 :confirm-text="$t('propagate')" @confirm="onConfirmPropagate"
                                 @cancel="onCloseModal"
                                 :productMaster="selectProductMaster"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { normalizeStr } from '@core/helpers';
import { createErrorNotification, createSuccessNotification } from '@ulibs/unnotificationsqueue';
import DynameatConfirmationModal from '@dynameat/components/DynameatConfirmationModal';
import { ProductMaster } from '../models';
import ProductMasterCreateEditModal from '../components/ProductMasterCreateEditModal.vue';
import ProductMasterRow from '../components/productMasterRow.vue';
import ProductMasterFilter from '../components/productMasterFilter.vue';
import ProductMasterPropagateModal from '../components/ProductMasterPropagateModal.vue';

@Component
@Components({
  ProductMasterCreateEditModal,
  ProductMasterRow,
  DynameatConfirmationModal,
  ProductMasterFilter,
  ProductMasterPropagateModal
})
@MapActions(['productMasterListRequest', 'createProductMasterRequest', 'updateProductMasterRequest', 'deleteProductMasterRequest', 'propagateProductMasterRequest', 'masterFeatureListRequest', 'addNotification', 'masterProductListSearchRequest'])
@MapGetters(['productMasterList', 'masterFeatureList', 'productSearchList', 'productSearchProgress', 'pointOfSaleList'])
export default class ProductMasterList extends Vue {
  productMasterFilter = ''

  normalizedNamesMap = new Map()

  selectProductMaster = null;

  createEditProductMasterModal = false;

  typeModal = 'create'

  deleteConfirmationModal = false;

  propagateModal = false;

  async created() {
    await this.productMasterListRequest();
    await this.masterFeatureListRequest();
    this.initializeNormalizedNamesMap();
  }

  get filteredProductMasterList() {
    let { productMasterList } = this;
    if (this.productMasterFilter !== '' && this.normalizedNamesMap.size) {
      const token = normalizeStr(this.productMasterFilter.trim());
      productMasterList = productMasterList
        .filter((el) => this.normalizedNamesMap.get(el.guid).normalizedName.includes(token));
    }
    return productMasterList;
  }

  initializeNormalizedNamesMap() {
    this.productMasterList.forEach((el) => {
      this.normalizedNamesMap.set(el.guid, {
        normalizedName: normalizeStr(el.name),
      });
    });
  }

  onEdit(productMaster) {
    this.selectProductMaster = ProductMaster.toInstance(productMaster.serialize());
    this.createEditProductMasterModal = true;
    this.typeModal = 'edit';
  }

  async onDelete(productMaster) {
    this.selectProductMaster = ProductMaster.toInstance(productMaster.serialize());
    this.deleteConfirmationModal = true;
  }

  async onConfirmPropagate() {
    try {
      await this.propagateProductMasterRequest(this.selectProductMaster);
      this.addNotification(createSuccessNotification(this.$t('propagateProductMasterSuccess', [this.selectProductMaster.name]), null, 3000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('propagateProductMasterError', [this.selectProductMaster.name])));
    } finally {
      this.onCloseModal();
      await this.productMasterListRequest();
    }
  }

  async onConfirmDelete() {
    try {
      await this.deleteProductMasterRequest(this.selectProductMaster);
      this.addNotification(createSuccessNotification(this.$t('deleteProductMasterSuccess', [this.selectProductMaster.name]), null, 3000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('deleteProductMasterError', [this.selectProductMaster.name])));
    } finally {
      this.onCloseModal();
      await this.productMasterListRequest();
    }
  }

  onProductMasterSearch(string) {
    this.productMasterFilter = string;
  }

  onPropagate(productMaster) {
    this.selectProductMaster = ProductMaster.toInstance(productMaster.serialize());
    this.propagateModal = true;
  }

  openModal() {
    this.selectProductMaster = ProductMaster.toInstance();
    this.createEditProductMasterModal = true;
    this.typeModal = 'create';
  }

  async onCreateProductMaster(productMaster) {
    try {
      await this.createProductMasterRequest(productMaster);
      this.addNotification(createSuccessNotification(this.$t('createProductMasterSuccess', [productMaster.name]), null, 3000));
    } catch (e) {
      console.log(e);
      this.addNotification(createErrorNotification(this.$t('createProductMasterError', [productMaster.name])));
    } finally {
      this.onCloseModal();
    }
  }

  async onEditProductMaster(productMaster) {
    try {
      await this.updateProductMasterRequest(productMaster);
      this.addNotification(createSuccessNotification(this.$t('editProductMasterSuccess', [productMaster.name]), null, 3000));
    } catch (e) {
      console.log(e);
      this.addNotification(createErrorNotification(this.$t('editProductMasterError', [productMaster.name])));
    } finally {
      this.onCloseModal();
    }
  }

  async onConfirmProductMaster(productMaster) {
    if (this.typeModal === 'create') {
      await this.onCreateProductMaster(productMaster);
    } else {
      await this.onEditProductMaster(productMaster);
    }
    await this.productMasterListRequest();
  }

  onCloseModal() {
    this.createEditProductMasterModal = false;
    this.deleteConfirmationModal = false;
    this.selectProductMaster = null;
    this.propagateModal = false;
  }
}
</script>
<style scoped>

</style>
